import { Box } from '@chakra-ui/react';
import { useRouteMatch } from 'react-router-dom';

// Custom Components.
import OptionsRow from './OptionsRow';
import BuildingOption from './BuildingOption';
import OptionsContainer from './OptionsContainer';

// Images.
import standAlone from 'img/sun-capital/Master plan/Aurora/Stand alone main cover.jpg';
import townHouse from 'img/sun-capital/Master plan/Aurora/Townhouse main cover.jpg';
import twinHouse from 'img/sun-capital/Master plan/Aurora/Twin House main Cover.jpg';

type Props = {};

export default function AllBuildings(props: Props) {
  const { path } = useRouteMatch();

  return (
    <OptionsContainer>
      <OptionsRow>
        <BuildingOption
          typeName="stand-alone"
          planUrl={`${path}/stand-alone/plan`}
          buildingName="Stand Alone"
          image={standAlone}
        />
        <BuildingOption
          typeName="townhouse"
          planUrl={`${path}/townhouse/plan`}
          buildingName="Townhouse"
          image={townHouse}
        />
      </OptionsRow>
      <OptionsRow>
        <BuildingOption
          typeName="twin-house"
          planUrl={`${path}/twin-house/plan`}
          buildingName="Twin House"
          image={twinHouse}
        />
        <Box flex={1} h="100%" />
      </OptionsRow>
    </OptionsContainer>
  );
}
